import {
  FormCheckbox,
  FormDatePicker,
  FormLabel,
  FormSectionHeader,
  FormSelect,
  Heading,
  Loader,
  FormInput,
  
  DateRangePicker,
  CustomTableHead,
  CustomTableCell,
} from "@/components";
import useAddEditPayment from "./useAddEditPayment";
import { FormProvider } from "react-hook-form";

import moment from "moment";
import {
  Button,
  Input,
  Label,
  Switch,
  Table,
  TableBody,
  TableHeader,
  TableRow,
} from "@/components/ui";
import { cn, formatAmount } from "@/lib/utils";
import {
  ACCOUNT_NAME,
  APPROVED_AMT,
  BANK_ACCOUNT,
  BANK_CHARGES,
  BASELINE_DATE,
  CHECK,
  CHEQUE_NO,
  COMMENT,
  DEDUCTION_AMT,
  DOC_NO,
  DOC_TYPE,
  DOCUMENT_ID,
  DOCUMENT_TYPE,
  DRCR,
  DUE_DATE,
  HEADER_TEXT,
  INVOICE_AMT,
  INVOICE_DATE,
  INVOICE_NO,
  INVOICE_REF,
  LINE_ITEMS,
  PAYABLE_AMT,
  PAYMENT_AMOUNT,
  PAYMENT_DATE,
  PAYMENT_METHOD,
  PAYMENT_TERMS,
  POSTING_DATE,
  POSTING_MONTH,
  POSTING_YEAR,
  RESIDUAL,
  VENDOR_ID,
} from "./consts";

const AddEditPayment = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    balanceAmount,
    vendorList,
    isVendorLoading,
    onCancel,
    breadcrumbTitle,
    isDocumentTypeLoading,
    documentTypes,
    keys,
    allDisabled,
    isPaymentMethodLoading,
    isPaymentTermLoading,
    onVendorChange,
    isLineItemsLoading,
    isPaymentPending,
    glData,
    isLoadingGlMaster,
    filterCriteria,
    onChangeFilterCriteria,
    onApplyFilter,
    onClearFilter,
    paymentId,
    isLoadingPaymentInvoice,
    isPosted,
    documentId,
    isPark,
    isPaymentPostPending,
    parkAction,
    hasUpdatePermission,
    hasPostPermission,
    isView,
    isEntryView,
    setIsEntryView
  } = useAddEditPayment();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6 !pt-0">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between sticky top-[10px] z-10 bg-g-10">
        <Heading
          title={breadcrumbTitle}
          breadcrumbData={breadcrumbData}
          showBack
          onBackClick={onBackClick}
        />
        {isPaymentMethodLoading || isPaymentTermLoading || isLoadingGlMaster ? (
          <></>
        ) : (
          <div className="grid grid-cols-1 mt-[20px] gap-[10px]">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[10px]">
              <div className="relative">
                <FormLabel>{"Payment Term"}</FormLabel>
                <Input
                  name={PAYMENT_TERMS}
                  placeholder="Please enter"
                  value={form.watch(PAYMENT_TERMS)}
                  disabled
                />
              </div>
              <div className="relative">
                <FormLabel>{"Payment Method"}</FormLabel>
                <Input
                  name={PAYMENT_METHOD}
                  placeholder="Please enter"
                  value={form.watch(PAYMENT_METHOD)}
                  disabled
                />
              </div>
              <div className="relative">
                <FormLabel>
                  {"Posting Period"}
                  <span className="text-red-700">{"*"}</span>
                </FormLabel>
                <Input
                  name={POSTING_MONTH}
                  placeholder="Please enter"
                  value={form.watch(POSTING_MONTH)}
                  disabled
                />
              </div>
              <div className="relative">
                <FormLabel>
                  {"Posting Year"}
                  <span className="text-red-700">{"*"}</span>
                </FormLabel>
                <Input
                  name={POSTING_YEAR}
                  placeholder="Please enter"
                  value={form.watch(POSTING_YEAR)}
                  disabled
                />
              </div>
            </div>
            <div className="flex items-center justify-center max-w-[300px]">
              Balance Amount:{"  "}
              <span
                className={cn(
                  balanceAmount == 0 ? "text-green-600" : "text-red-600",
                  "ml-2"
                )}
              >
                {formatAmount(balanceAmount, 2)}
              </span>
            </div>
          </div>
        )}
      </div>

      {isVendorLoading ||
      isDocumentTypeLoading ||
      isLoadingPaymentInvoice ||
      isLoadingGlMaster ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[10px] rounded-lg px-[30px] py-[15px]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px] items-center">
                <FormSectionHeader>Document Header</FormSectionHeader>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-7 gap-[25px]">
                {documentId ? (
                  <FormInput
                    name={DOCUMENT_ID}
                    control={form.control}
                    label="Document Id"
                    placeholder="Please enter"
                    error={errors[DOCUMENT_ID]?.message}
                    isRequired={requiredFields.includes(DOCUMENT_ID)}
                    disabled
                  />
                ) : (
                  <></>
                )}
                <FormSelect
                  key={keys.documentTypes}
                  name={DOCUMENT_TYPE}
                  control={form.control}
                  label="Document Type"
                  placeholder="Please select"
                  error={errors[DOCUMENT_TYPE]?.message}
                  isRequired={requiredFields.includes(DOCUMENT_TYPE)}
                  options={(documentTypes || [])?.map((data: any) => ({
                    value: data?.documentTypeId?.toString(),
                    label: data?.documentType,
                  }))}
                  disabled
                />
                <FormSelect
                  key={keys.vendorList}
                  name={VENDOR_ID}
                  control={form.control}
                  label="Vendor Name"
                  placeholder="Please enter"
                  error={errors[VENDOR_ID]?.message}
                  isRequired={requiredFields.includes(VENDOR_ID)}
                  options={(vendorList || [])?.map((data: any) => ({
                    value: data?.vendorId?.toString(),
                    label: data?.vendorName,
                  }))}
                  onChange={onVendorChange}
                  disabled={allDisabled}
                />
                <FormSelect
                  key={keys.bankName}
                  name={BANK_ACCOUNT}
                  control={form.control}
                  label="Bank Account"
                  placeholder="Please select"
                  error={errors[BANK_ACCOUNT]?.message}
                  isRequired={requiredFields.includes(BANK_ACCOUNT)}
                  disabled={allDisabled}
                  options={(glData?.data || [])
                    ?.sort((a: any, b: any) =>
                      a.glAccountNumber?.localeCompare(b.glAccountNumber)
                    )
                    ?.map((data: any) => {
                      return {
                        label: `${data?.glAccountNumber} - ${data?.accountShortDesc}`,
                        value: data?.glMasterId?.toString(),
                      };
                    })}
                  onChange={(value: any) => {
                    form.setValue(
                      ACCOUNT_NAME,
                      glData?.data
                        ?.find((data: any) => data?.glMasterId == value)
                        ?.accountShortDesc?.toString() || ""
                    );
                  }}
                />
                <FormInput
                  name={ACCOUNT_NAME}
                  control={form.control}
                  label="Account Name"
                  placeholder="Please enter"
                  error={errors[ACCOUNT_NAME]?.message}
                  isRequired={requiredFields.includes(ACCOUNT_NAME)}
                  disabled
                />
                <FormDatePicker
                  name={POSTING_DATE}
                  control={form.control}
                  label="Posting Date"
                  placeholder="Please select"
                  error={errors[POSTING_DATE]?.message}
                  isRequired
                  onChange={() => {
                    form.setValue(
                      POSTING_YEAR,
                      moment(form.getValues()[POSTING_DATE]).format("YYYY")
                    );
                    form.setValue(
                      POSTING_MONTH,
                      moment(form.getValues()[POSTING_DATE]).format("MMM")
                    );
                  }}
                  disabled={allDisabled}
                />
                <FormInput
                  name={PAYMENT_AMOUNT}
                  control={form.control}
                  label="Payment Amount"
                  placeholder="Please enter"
                  error={errors[PAYMENT_AMOUNT]?.message}
                  isRequired={requiredFields.includes(PAYMENT_AMOUNT)}
                  disabled={allDisabled}
                  startIcon="$"
                  onChange={(e: any) => {
                    form.setValue(PAYABLE_AMT, e.target.value);
                  }}
                  variant="float"
                  maxLength="10"
                />
                <FormInput
                  name={CHEQUE_NO}
                  control={form.control}
                  label="Cheque No."
                  placeholder="Please enter"
                  error={errors[CHEQUE_NO]?.message}
                  isRequired={requiredFields.includes(CHEQUE_NO)}
                  disabled={allDisabled}
                />
                <FormDatePicker
                  name={PAYMENT_DATE}
                  control={form.control}
                  label="Payment Date"
                  placeholder="Please select"
                  error={errors[PAYMENT_DATE]?.message}
                  isRequired
                  disabled={allDisabled}
                />
                <FormInput
                  name={BANK_CHARGES}
                  control={form.control}
                  label="Bank Charges"
                  placeholder="Please enter"
                  error={errors[BANK_CHARGES]?.message}
                  isRequired={requiredFields.includes(BANK_CHARGES)}
                  disabled={allDisabled}
                  startIcon="$"
                  variant="float"
                  maxLength="10"
                />
                <FormInput
                  name={DEDUCTION_AMT}
                  control={form.control}
                  label="Deduction Amount"
                  placeholder="Please enter"
                  error={errors[DEDUCTION_AMT]?.message}
                  isRequired={requiredFields.includes(DEDUCTION_AMT)}
                  disabled={allDisabled}
                  startIcon="$"
                  variant="float"
                  maxLength="10"
                />
                <FormInput
                  name={COMMENT}
                  control={form.control}
                  label="Header Text"
                  placeholder="Please enter"
                  error={errors[COMMENT]?.message}
                  isRequired={requiredFields.includes(COMMENT)}
                  disabled={allDisabled}
                />
              </div>
            </div>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[15px]">
              <div
                className={cn(
                  "grid grid-cols-1",
                  paymentId ? "md:grid-cols-3 mb-3" : ""
                )}
              >
                <FormSectionHeader className="">Line Items</FormSectionHeader>
                {paymentId ? (
                  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-[20px] md:col-span-2">
                    <div className="relative">
                      <FormLabel>{"Doc No."}</FormLabel>
                      <Input
                        placeholder="Please enter"
                        value={filterCriteria?.[DOC_NO]}
                        onChange={(e) =>
                          onChangeFilterCriteria(DOC_NO, e.target.value)
                        }
                      />
                    </div>
                    <div className="relative">
                      <FormLabel>{"Invoice No."}</FormLabel>
                      <Input
                        placeholder="Please enter"
                        value={filterCriteria?.[INVOICE_NO]}
                        onChange={(e) =>
                          onChangeFilterCriteria(INVOICE_NO, e.target.value)
                        }
                      />
                    </div>
                    <div className="relative md:col-span-2">
                      <FormLabel>{"Invoice No."}</FormLabel>
                      <DateRangePicker
                        value={filterCriteria?.invoiceDateRange}
                        onChange={(value: any) =>
                          onChangeFilterCriteria("invoiceDateRange", value)
                        }
                      />
                    </div>
                    <Button onClick={onApplyFilter} type="button">
                      Apply
                    </Button>
                    <Button
                      variant="outline"
                      type="button"
                      onClick={onClearFilter}
                    >
                      Clear All
                    </Button>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              {isPosted ? (
                <div className="w-full flex items-center justify-end gap-2 h-[38px] mb-5">
                  <Label className="text-[10px]">GL View</Label>
                  <Switch
                    checked={isEntryView}
                    onCheckedChange={setIsEntryView}
                  />
                  <Label className="text-[10px]">Entry View</Label>
                </div>
              ) : (
                <></>
              )}

              <div className="overflow-x-auto w-full">
                <div className="min-w-[2000px]">
                  <Table>
                    <TableHeader>
                      <TableRow className="mb-3 rounded">
                        <CustomTableHead className="w-[30px]"></CustomTableHead>
                        <CustomTableHead className="w-[150px]">
                          Invoice Date
                        </CustomTableHead>
                        <CustomTableHead className="w-[150px]">
                          Invoice No.
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Invoice Ref.
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Doc No.
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Doc Type
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Header Text
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          BaseLine Date
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Due Date
                        </CustomTableHead>
                        {/* <CustomTableHead className="w-[100px]">
                          Pay Block
                        </CustomTableHead> */}
                        <CustomTableHead className="w-[100px]">
                          Dr/Cr
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Invoice Amt.
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Approved Amt.
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Total Payable Amt.
                        </CustomTableHead>
                        <CustomTableHead className="w-[100px]">
                          Residual Amt.
                        </CustomTableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {isLineItemsLoading ? (
                        <Loader variant="secondary" />
                      ) : form.watch(LINE_ITEMS)?.length ? (
                        form.watch(LINE_ITEMS)?.map((_: any, index: number) => {
                          return (
                            <TableRow
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <CustomTableCell>
                                <FormCheckbox
                                  name={`${LINE_ITEMS}.${index}.${CHECK}`}
                                  control={form.control}
                                  label=""
                                  placeholder=""
                                  error={
                                    (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                      CHECK
                                    ]?.message
                                  }
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${CHECK}`
                                  )}
                                  disabled={allDisabled}
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormDatePicker
                                  name={`${LINE_ITEMS}.${index}.${INVOICE_DATE}`}
                                  control={form.control}
                                  label=""
                                  placeholder="Please select"
                                  error={
                                    (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                      INVOICE_DATE
                                    ]?.message
                                  }
                                  isRequired={requiredFields?.includes(
                                    `${LINE_ITEMS}.${index}.${INVOICE_DATE}`
                                  )}
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${INVOICE_NO}`}
                                  error={errors[INVOICE_NO]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${INVOICE_NO}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please enter"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${INVOICE_REF}`}
                                  error={errors[INVOICE_REF]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${INVOICE_REF}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please enter"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${DOC_NO}`}
                                  error={errors[DOC_NO]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${DOC_NO}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please enter"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${DOC_TYPE}`}
                                  error={errors[DOC_TYPE]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${DOC_TYPE}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please enter"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${HEADER_TEXT}`}
                                  error={errors[HEADER_TEXT]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${HEADER_TEXT}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please enter"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormDatePicker
                                  name={`${LINE_ITEMS}.${index}.${BASELINE_DATE}`}
                                  error={errors[BASELINE_DATE]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${BASELINE_DATE}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please select"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormDatePicker
                                  name={`${LINE_ITEMS}.${index}.${DUE_DATE}`}
                                  error={errors[DUE_DATE]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${DUE_DATE}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please select"
                                  disabled
                                />
                              </CustomTableCell>
                              {/* <CustomTableCell>
                                <X className="stroke-red-600 stroke-3" />
                              </CustomTableCell> */}
                              <CustomTableCell>
                                <FormInput
                                  key={keys.drcr}
                                  name={`${LINE_ITEMS}.${index}.${DRCR}`}
                                  control={form.control}
                                  label=""
                                  placeholder="Select"
                                  error={
                                    (errors[LINE_ITEMS] as any)?.[`${index}`]?.[
                                      DRCR
                                    ]?.message
                                  }
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${DRCR}`
                                  )}
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${INVOICE_AMT}`}
                                  error={errors[INVOICE_AMT]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${INVOICE_AMT}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please enter"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${APPROVED_AMT}`}
                                  error={errors[APPROVED_AMT]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${APPROVED_AMT}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Please enter"
                                  disabled
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${PAYABLE_AMT}`}
                                  error={errors[PAYABLE_AMT]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${PAYABLE_AMT}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Enter"
                                  disabled={isView || isPosted}
                                />
                              </CustomTableCell>
                              <CustomTableCell>
                                <FormInput
                                  name={`${LINE_ITEMS}.${index}.${RESIDUAL}`}
                                  error={errors[RESIDUAL]?.message}
                                  isRequired={requiredFields.includes(
                                    `${LINE_ITEMS}.${index}.${RESIDUAL}`
                                  )}
                                  control={form.control}
                                  label=""
                                  placeholder="Enter"
                                  disabled={isView || isPosted}
                                />
                              </CustomTableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow className="col-span-13">
                          <CustomTableCell>No Data Found.</CustomTableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
            {/* <div className="bg-white mt-[10px] rounded-lg px-[30px] py-[15px]">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[20px] items-center">
                <div className="grid grid-cols-1 md:grid-cols-2 items-center">
                  <span className="text-primary text-[14px] font-[600]">
                    Payable Amount
                  </span>
                  <Input
                    name={PAYABLE_AMT}
                    placeholder="Please enter"
                    value={form.watch(PAYABLE_AMT)}
                    disabled
                    startIcon="$"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 items-center">
                  <span className="text-primary text-[14px] font-[600]">
                    Total Payable
                    <br />
                    <span className="text-[10px]">
                      (Selected Amt. + Bank Charges)
                    </span>
                  </span>
                  <Input
                    name={TOTAL_PAYABLE}
                    placeholder="Please enter"
                    value={form.watch(TOTAL_PAYABLE)}
                    disabled
                    startIcon="$"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 items-center">
                  <span className="text-primary text-[14px] font-[600]">
                    Residual <br />
                    <span className="text-[10px]">
                      (Payable Amt. - Total Payable)
                    </span>
                  </span>
                  <Input
                    name={RESIDUAL}
                    placeholder="Please enter"
                    value={form.watch(RESIDUAL)}
                    disabled
                    startIcon="$"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 items-center">
                  <span className="text-primary text-[14px] font-[600]">
                    Un-assigned <br />
                    <span className="text-[10px]">
                      (Payment Amt. - (Total Payable + Residual))
                    </span>
                  </span>
                  <Input
                    name={UNASSIGNED}
                    placeholder="Please enter"
                    value={form.watch(UNASSIGNED)}
                    disabled
                    startIcon="$"
                  />
                </div>
              </div>
            </div> */}
            <div className="flex flex-row justify-end gap-3  py-3">
              <Button
                variant="outline"
                type="button"
                onClick={onCancel}
                disabled={isPaymentPending || isPaymentPostPending}
              >
                Cancel
              </Button>
              {isPark ? (
                <>
                  {hasUpdatePermission && <Button type="submit" disabled={isPaymentPending}>
                    {isPaymentPending ? <Loader variant="secondary" /> : <></>}{" "}
                    Park
                  </Button>}
                  {hasPostPermission && <Button type="button" disabled={isPaymentPostPending} onClick={() => {
                    parkAction.current = "post";
                    form.handleSubmit(onSubmit)();
                  }}>
                    {isPaymentPostPending ? <Loader variant="secondary" /> : <></>}{" "}
                    Post
                  </Button>}
                </>
              ) : isPosted ? <></> : (
                <Button type="submit" disabled={isPaymentPending}>
                  {isPaymentPending ? <Loader variant="secondary" /> : <></>}{" "}
                  Park
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default AddEditPayment;
